import { ApiService } from '../../theme/utils/api.service';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { NoInternetHelper } from '../../theme/utils/no-internet-helper';
import { OwnerCo } from '../../model/syndic/owner-co';
import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root'
})
export class OwnerCoService {

  ownerCo: OwnerCo;
  public edit: boolean = false;
  public uuid: string = '';
  public uuidSyndic: string = '';
  private url = 'private/trustee/ownerco';
  private urlBase = environment.publicUrl;

  constructor(private api: ApiService) { }

  setOwnerCo(ownerCo: OwnerCo) {
    this.ownerCo = ownerCo;
  }

  getOwnerCo(): OwnerCo {
    return this.ownerCo;
  }

  add(data: OwnerCo): Observable<any> {
    if (!navigator.onLine) {
      NoInternetHelper.internet();
      return Observable.create(obs => { obs.next(); obs.complete(); });
    }
    if (data.uuid) {
      return this.update(data);
    } else {
      return this.create(data);
    }
  }

  create(data: OwnerCo): Observable<any> {
    return this.api._post(`${this.url}/new`, data).pipe(
      map((response: any) => response),
      catchError((error: any) => throwError(error))
    );
  }

  update(data: OwnerCo): Observable<any> {
    return this.api._post(`${this.url}/${data?.uuid}/edit`, data).pipe(
      map((response: any) => response),
      catchError((error: any) => throwError(error))
    );
  }

  getList(trustee?: string): Observable<any[]> {
    if (!navigator.onLine) {
      NoInternetHelper.internet();
      return Observable.create(obs => { obs.next(); obs.complete(); });
    }
    return this.api._get(`${this.url}`, { trustee: trustee }).pipe(
      map((response: any) => response),
      catchError((error: any) => throwError(error))
    );
  }

  getSingle(uuid: string): Observable<OwnerCo> {
    if (!navigator.onLine) {
      NoInternetHelper.internet();
      return Observable.create(obs => { obs.next(); obs.complete(); });
    }
    return this.api._get(`${this.url}/${uuid}/show`).pipe(
      map((response: any) => response.data),
      catchError((error: any) => throwError(error))
    );
  }

  getDelete(uuid: string): Observable<OwnerCo> {
    if (!navigator.onLine) {
      NoInternetHelper.internet();
      return Observable.create(obs => { obs.next(); obs.complete(); });
    }
    return this.api._delete(`${this.url}/${uuid}/delete`).pipe(
      map((response: any) => response),
      catchError((error: any) => throwError(error))
    );
  }

  getBalance(uuid: string): Observable<any> {
    if (!navigator.onLine) {
      NoInternetHelper.internet();
      return Observable.create(obs => { obs.next(); obs.complete(); });
    }
    return this.api._get(`${this.url}/${uuid}/balance`).pipe(
      map((response: any) => response.data),
      catchError((error: any) => throwError(error))
    );
  }

  getPrinter(type: string, agencyKey: string, userKey: string, data: any, syndicUuid?: string): void {
    if (!navigator.onLine) {
      NoInternetHelper.internet();
      return;
    }
    let url = 'printer/trustee/ownerco/' + agencyKey + '/' + userKey;
    if (type === 'LISTE') {
      url += '/' + syndicUuid;
      if (data && data !== undefined) {
        for (const k in data) {
          if (data.hasOwnProperty(k)) {
            if (k !== 'uuid') {
              url += '/' + (data[k] !== undefined && data[k] !== '' ? data[k] : null);
            }
          }
        }
      } else {
        url += '/null/null/null/null/null/null/null/null/null/DESC/null/null/null/null/10/null';
      }
    }
    window.open(`${this.urlBase}/${url}`, '_blank');
  }
}
